<div class="dialog-header mb-5">
	<h1 class="dialog-title" mat-dialog-title>
		<span i18n="Add Element Button@@assetTemplateSelectorAddElementButtonLabel">Add {{ data?.elementTitle }}</span>
	</h1>
</div>

<div mat-dialog-content>

	<form [formGroup]="form" *localVar="(siteCopy$ | async) as copy">
		<p class="title"
		   i18n="Add Template Dialog Template Name@@addTemplateDialogTemplateNameLabel"
		>Template name</p>
		<app-text-input label="Template name"
						i18n-label="Add Template Dialog Template Name@@addTemplateDialogTemplateNameLabel"
						[parentForm]="form"
						[controlName]="'name'"
						[fullWidth]="true"
		></app-text-input>

		<p class="title"
		   i18n="Add Template Dialog Businesses@@addTemplateDialogBusinessesLabel"
		>{{ copy?.businessNameLabelPlural || 'Businesses' }}</p>
		<p class="subtitle"
		   i18n="Add Template Dialog Businesses Descripion@@addTemplateDialogBusinessesDescriptionLabel"
		>Select which {{ copy?.businessNameLabelSingular }} the template is for</p>

		<app-select-input
			[parentForm]="form"
			controlName="creativePackageBusinessIds"
			[currentValue]="form.value?.creativePackageBusinessIds"
			[options]="sessionQuery.isAtLeastSuperAdmin() ? ([{ value: 'ALL', label: 'All' }].concat(businessOptions)) : businessOptions"
			[optionValueKey]="'value'"
			[fullWidth]="true"
			[showSearch]="true"
			[multiple]="true"
			label="Businesses"
			i18n-label="Add Template Dialog Businesses@@addTemplateDialogBusinessesLabel"
			hint="Select which business the template is for"
			i18n-hint="Add Template Dialog Businesses Descripion@@addTemplateDialogBusinessesDescriptionLabel"
		></app-select-input>
	</form>
</div>

<div mat-dialog-actions class="dialog-footer">
	<button
		mat-flat-button
		[mat-dialog-close]="null"
		color="secondary"
		class="submit margin-left-auto"
		i18n="Dialog Action Button@@addExternalPaymentMethodDialogCancelButtonLabel"
	>
		Cancel
	</button>

	<button
		mat-flat-button
		color="primary"
		class="dark submit margin-right-auto"
		i18n="Add Template Dialog Action Button@@addTemplateDialogActionButtonLabel"
		[disabled]="!isValid()"
		(click)="submit()"
	>
		Create template
	</button>
</div>
